(function () {

  const startExperiment = () => {
    if (document.querySelector('#cart-summary.hos-6')) return;

    document.querySelector('#cart-summary').classList.add('hos-6');

    const nonStickSection = document.querySelector('.cart-form--non-stick.cart-summary__section');
    const promoSection = document.querySelector('.cart-summary__promo.cart-summary__section');
    const checkoutForm = document.querySelector('.cart-form.cart-form--checkout.cart-form--checkout--sticky-true');
    const buttonToReplace = document.querySelector('button.cart-accordion-btn.btn.plain-text');
    const linkElement = document.querySelector('a.cart-summary__cart-link');
    const header = document.querySelector('h6#cart-summary-products-header');
    const itemCount = document.querySelector('small.cart-summary__item-list-header__count');
    const titleVariant = document.querySelectorAll('.cart-summary-item__title-variant');
    const price = document.querySelectorAll('.cart-summary-item__price');

    // Move non-stick section before promo section
    if (nonStickSection && promoSection) {
      promoSection.parentNode.insertBefore(nonStickSection, promoSection);
    }

    // Move checkout form before promo section
    if (checkoutForm && promoSection) {
      promoSection.parentNode.insertBefore(checkoutForm, promoSection);
    }

    // Replace accordion button with cart link
    if (buttonToReplace && linkElement) {
      buttonToReplace.replaceWith(linkElement.cloneNode(true));
    }

    // Redirect cart links to /cart
    if (linkElement) {
      document.querySelectorAll('a.cart-summary__cart-link').forEach(function (el) {
        if (el) {
          el.addEventListener('click', function () {
            window.location.assign('https://growhoss.com/cart');
          });
        }
      });
    }

    // Wrap header and item count together
    if (header && itemCount) {
      const wrapperDiv = document.createElement('div');
      header.parentNode.insertBefore(wrapperDiv, header);
      wrapperDiv.appendChild(header);
      wrapperDiv.appendChild(itemCount);
    }

    // Wrap each title/variant + price pair in a cart-container div
    if (titleVariant.length === price.length) {
      titleVariant.forEach((variant, index) => {
        const priceElement = price[index];
        if (variant && priceElement) {
          const wrapperDiv = document.createElement('div');
          wrapperDiv.className = 'cart-container';
          variant.parentNode.insertBefore(wrapperDiv, variant);
          wrapperDiv.appendChild(variant);
          wrapperDiv.appendChild(priceElement);
        }
      });
    } else {
      console.error('titleVariant and price arrays have different lengths!');
    }

    // Rename header to "Cart"
    if (header) {
      header.textContent = 'Cart';
    }

    // Replace promo heading h6 with div
    const promoHeading = document.querySelector('h6#cart-summary-promo-heading');
    if (promoHeading) {
      const newDiv = document.createElement('div');
      newDiv.className = promoHeading.className;
      newDiv.innerHTML = promoHeading.innerHTML;
      promoHeading.parentNode.replaceChild(newDiv, promoHeading);
    }

    // Add "View" text to accordion button
    const button = document.querySelector('.cart-accordion-btn.btn.plain-text.cart-accordion-btn--collapsed');
    if (button && button.querySelector('svg')) {
      const viewDiv = document.createElement('div');
      viewDiv.textContent = 'View';
      viewDiv.classList.add('view-text');
      button.insertBefore(viewDiv, button.querySelector('svg'));
    }

    // =====================
    // Free Shipping Progress Bar
    // =====================
    function insertProgressBar() {
      const cartFormSection = document.querySelector('.cart-form.cart-summary__section');
      const priceElement = document.querySelector('.cart-summary__subtotal .theme-money');

      if (priceElement) {
        const dollarAmount = priceElement.childNodes[0] && priceElement.childNodes[0].textContent.trim().replace(/[^0-9.-]+/g, '');
        const supElement = priceElement.querySelector('sup');
        const centsAmount = (supElement && supElement.textContent.trim()) || '00';
        const cartTotal = parseFloat(`${dollarAmount}.${centsAmount}`);
        const cartSummary = document.querySelector('#cart-summary');

        if (!isNaN(cartTotal)) {
          const goal = 99.99;

          // Remove existing progress bar if present
          const existingProgressBar = document.querySelector('.cart-progress-outer-wrapper');
          if (existingProgressBar) existingProgressBar.remove();

          const outerWrapper = document.createElement('div');
          outerWrapper.classList.add('cart-progress-outer-wrapper');

          const progressWrapper = document.createElement('div');
          progressWrapper.classList.add('cart-progress-wrapper');

          if (cartTotal >= goal) {
            // Free shipping qualified
            progressWrapper.style.flexDirection = 'row';
            cartSummary.classList.add('freeship');

            const checkIconContainer = document.createElement('div');
            checkIconContainer.classList.add('free-shipping-icon-container');

            // Using inline SVG checkmark instead of imported asset
            checkIconContainer.innerHTML = `
              <svg width="8" height="7" viewBox="0 0 8 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.909 2L2.909 6L1.09082 4.18182" stroke="#FCFDFC" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/>
              </svg>
            `;

            const messageText = document.createElement('span');
            messageText.innerHTML = 'Your order qualifies for <strong>Free USA Shipping</strong>';

            progressWrapper.appendChild(checkIconContainer);
            progressWrapper.appendChild(messageText);
            checkIconContainer.parentElement.style.padding = '16px 20px';

          } else {
            // Show progress toward free shipping
            progressWrapper.style.flexDirection = 'column';
            cartSummary.classList.remove('freeship');

            const remainingAmount = Math.max(goal - cartTotal, 0);
            const message = document.createElement('p');
            message.classList.add('progress-message');
            message.innerHTML = `You're only <strong>$${remainingAmount.toFixed(2)}</strong> away from Free USA Shipping`;
            progressWrapper.appendChild(message);

            const progressContainer = document.createElement('div');
            progressContainer.classList.add('progress-container');

            const progressBar = document.createElement('div');
            progressBar.classList.add('progress-bar');
            progressContainer.appendChild(progressBar);
            progressWrapper.appendChild(progressContainer);

            const progressPercentage = Math.min((cartTotal / goal) * 100, 100);
            progressBar.style.width = `${progressPercentage}%`;

            const labelContainer = document.createElement('div');
            labelContainer.classList.add('progress-labels');

            const labelStart = document.createElement('span');
            labelStart.classList.add('progress-label');
            labelStart.textContent = '$0';

            const labelGoal = document.createElement('span');
            labelGoal.classList.add('progress-label');
            labelGoal.textContent = `$${goal}`;

            labelContainer.appendChild(labelStart);
            labelContainer.appendChild(labelGoal);
            progressWrapper.appendChild(labelContainer);
          }

          outerWrapper.appendChild(progressWrapper);

          if (cartFormSection) {
            cartFormSection.parentNode.insertBefore(outerWrapper, cartFormSection);
          }

          const progressWrapperEl = document.querySelector('.cart-progress-wrapper');
          if (progressWrapperEl) {
            const promoProductsSection = document.querySelector('#cart-summary .cart-summary__promo-products .cart-summary__section');
            if (promoProductsSection) {
              promoProductsSection.style.backgroundColor = '#F3F4F3';
            }
          }
        }
      }
    }

    insertProgressBar();

    // =====================
    // Recommendation Header Icon + Toggle
    // =====================
    const recommendationHeader = document.querySelector('#cart-summary > div > div.cart-summary__promo-products-title.cart-summary__section.cart-accordion-btn-container.border-top > div');

    if (recommendationHeader) {
      recommendationHeader.style.display = 'flex';
      recommendationHeader.style.alignItems = 'center';

      const svgDivContainer = document.createElement('div');
      svgDivContainer.classList.add('recommendation-icon-container');

      // Inline sparkle SVG instead of imported asset
      svgDivContainer.innerHTML = `
        <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="Group">
            <path id="Vector" d="M8.73003 5.32281C8.73003 5.21399 8.65347 5.12033 8.54691 5.09871L5.66475 4.51482C5.54058 4.31461 5.37315 4.14736 5.17292 4.02299L4.58903 1.14101C4.56741 1.03445 4.47375 0.957886 4.36493 0.957886C4.2561 0.957886 4.16245 1.03445 4.14082 1.14101L3.55694 4.02299C3.35672 4.14734 3.18947 4.31459 3.06511 4.51482L0.183122 5.09871C0.0765642 5.12034 0 5.21399 0 5.32281C0 5.43164 0.0765597 5.52529 0.183122 5.54692L3.06511 6.13081C3.18928 6.33102 3.3567 6.49827 3.55694 6.62263L4.14082 9.50462C4.16245 9.61118 4.2561 9.68774 4.36493 9.68774C4.47375 9.68774 4.56741 9.61118 4.58903 9.50462L5.17292 6.62263C5.37313 6.49828 5.54038 6.33104 5.66475 6.13081L8.54673 5.54692C8.65329 5.52529 8.73003 5.43147 8.73003 5.32281Z" fill="#182214"/>
            <path id="Vector_2" d="M12.8586 10.4701L10.7389 10.0407C10.6479 9.90087 10.5295 9.78227 10.3894 9.69124L9.96007 7.57155C9.93844 7.46499 9.84479 7.38843 9.73596 7.38843C9.62714 7.38843 9.53348 7.46499 9.51186 7.57155L9.08248 9.69124C8.94244 9.78228 8.82402 9.90069 8.73299 10.0407L6.6133 10.4701C6.50674 10.4917 6.43018 10.5854 6.43018 10.6942C6.43018 10.803 6.50674 10.8967 6.6133 10.9183L8.73299 11.3477C8.82403 11.4877 8.94244 11.6062 9.08248 11.6972L9.51186 13.8169C9.53349 13.9234 9.62714 14 9.73596 14C9.84479 14 9.93845 13.9234 9.96007 13.8169L10.3894 11.6972C10.5295 11.6062 10.6479 11.4877 10.7389 11.3477L12.8586 10.9183C12.9652 10.8967 13.0418 10.803 13.0418 10.6942C13.0419 10.5854 12.9652 10.4916 12.8586 10.4701Z" fill="#182214"/>
            <path id="Vector_3" d="M15.1218 2.7257L13.2581 2.34813C13.1784 2.22831 13.0766 2.12647 12.9568 2.04676L12.5792 0.183123C12.5576 0.0765645 12.4639 0 12.3551 0C12.2463 0 12.1526 0.0765601 12.131 0.183123L11.7534 2.04676C11.6336 2.12647 11.5316 2.22831 11.452 2.34813L9.5884 2.7257C9.48184 2.74733 9.40527 2.84098 9.40527 2.94981C9.40527 3.05863 9.48183 3.15229 9.5884 3.17391L11.452 3.55149C11.5316 3.6713 11.6336 3.77315 11.7534 3.85285L12.131 5.71649C12.1526 5.82305 12.2463 5.89961 12.3551 5.89961C12.4639 5.89961 12.5576 5.82305 12.5792 5.71649L12.9568 3.85285C13.0766 3.77315 13.1784 3.6713 13.2581 3.55149L15.1218 3.17391C15.2283 3.15229 15.3049 3.05863 15.3049 2.94981C15.3051 2.84098 15.2283 2.74733 15.1218 2.7257Z" fill="#182214"/>
          </g>
        </svg>
      `;

      recommendationHeader.insertBefore(svgDivContainer, recommendationHeader.firstChild);

      const textNode = recommendationHeader.childNodes[1];
      const textSpan = document.createElement('span');
      textSpan.classList.add('recommendation-text');
      textSpan.textContent = textNode.textContent;
      recommendationHeader.replaceChild(textSpan, textNode);

      const promoButton = document.querySelector('.cart-summary__promo-products-title.cart-summary__section.cart-accordion-btn-container');
      if (promoButton) {
        promoButton.addEventListener('click', () => {
          let viewTextElement = document.querySelector('.view-text');
          if (!viewTextElement) {
            const btn = document.querySelector('.cart-accordion-btn.plain-text');
            if (btn) {
              viewTextElement = document.createElement('div');
              viewTextElement.classList.add('view-text');
              btn.appendChild(viewTextElement);
            }
          }
          if (viewTextElement) {
            viewTextElement.textContent = viewTextElement.textContent === 'Hide' ? 'View' : 'Hide';
          }
        });
      }
    }

    // =====================
    // Recs open/close observer
    // =====================
    new MutationObserver((mutationsList) => {
      if (!mutationsList[0].target.matches('.hidden')) {
        document.querySelector('#cart-summary').classList.add('recs-open');
      } else {
        document.querySelector('#cart-summary').classList.remove('recs-open');
      }
    }).observe(document.querySelector('.cart-summary__promo-products'), { attributes: true });

    // =====================
    // Sticky container grouping
    // =====================
    const promoTitle = document.querySelector('.cart-summary__promo-products-title.cart-summary__section.cart-accordion-btn-container');
    const promoProducts = document.querySelector('.cart-summary__promo-products');
    const cartFormSticky = document.querySelector('form.cart-form.cart-form--checkout.cart-form--checkout--sticky-true');
    const cartFormNonStick = document.querySelector('.cart-form--non-stick.cart-summary__section');
    const cartSummary = document.querySelector('#cart-summary');

    if (promoTitle && promoProducts && cartFormSticky && cartFormNonStick && cartSummary) {
      const itemsList = cartSummary.querySelector('.cart-summary__item-list');
      const stickyContainer = document.createElement('div');
      stickyContainer.classList.add('sticky-container');
      stickyContainer.appendChild(promoTitle);
      stickyContainer.appendChild(promoProducts);
      stickyContainer.appendChild(cartFormNonStick);
      stickyContainer.appendChild(cartFormSticky);
      cartSummary.appendChild(stickyContainer);
      itemsList.classList.add('has-recs');
    }
  };

  // =====================
  // Init — wait for cart then observe mutations
  // =====================
  function init() {
    document.body.classList.add('hos-6');
    const cartDrawer = document.querySelector('#shopify-section-cart-drawer');
    const subtotalLabel = document.querySelector('.cart-summary__subtotal-label');
    if (subtotalLabel) {
      startExperiment();
    }

    if (cartDrawer) {
      new MutationObserver(startExperiment).observe(cartDrawer, { subtree: true, childList: true });
    }
  }
  init();
})();